var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { API, UPLOAD_API } from 'globals/api';
import { RESOURCES_END_POINTS } from 'globals/apiEndPoints';
import { APIMethod } from 'globals/enums';
import FileUploadDataParser from './parser/fileUploadDataParser';
/**
 * @description API service to get the signed urls to upload files
 * @function postSignedUrlService
 * @param {IPostSignedUrlParams} params of get signed url api
 * @returns {SignedUrlDataModel[]}
 */
export function postSignedUrlService(params) {
    return __awaiter(this, void 0, Promise, function () {
        var signedUrl, dataParser, signedUrlData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, API({
                            url: RESOURCES_END_POINTS.GET_SIGNED_URL,
                            method: APIMethod.Post,
                            data: params.data,
                        })];
                case 1:
                    signedUrl = _a.sent();
                    dataParser = new FileUploadDataParser();
                    signedUrlData = dataParser.parseSignedUrlData(signedUrl === null || signedUrl === void 0 ? void 0 : signedUrl.data);
                    return [2 /*return*/, signedUrlData];
                case 2:
                    error_1 = _a.sent();
                    console.log(error_1);
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    });
}
/**
 * @description API service to upload files
 * @function postUploadFileService
 * @param {IPostUploadFileParams} params of upload files api
 */
export var postUploadFileService = function (params) { return __awaiter(void 0, void 0, Promise, function () {
    var error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, UPLOAD_API(params)];
            case 1:
                _a.sent();
                return [2 /*return*/, true];
            case 2:
                error_2 = _a.sent();
                console.log(error_2);
                throw error_2;
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * @description API service to get the signed urls to upload files
 * @function getSignedUrlService
 * @param {IGetSignedUrlParams} params of get signed url api
 * @returns {SignedUrlDataModel[]}
 */
/**
 * @description API service to get the signed urls to upload files
 * @function getSignedUrlService
 * @param {IGetSignedUrlParams} params of get signed url api
 * @returns {SignedUrlDataModel[]}
 */
export function getSignedUrlService(params) {
    return __awaiter(this, void 0, Promise, function () {
        var _a, senior_id, caregiver_id, files, version, resource_version, idValue, url, response, error_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    _a = params.data, senior_id = _a.senior_id, caregiver_id = _a.caregiver_id, files = _a.files, version = _a.version, resource_version = _a.resource_version;
                    idValue = caregiver_id || senior_id;
                    if (!idValue)
                        throw new Error('Missing senior_id or caregiver_id');
                    url = "".concat(RESOURCES_END_POINTS.GET_SIGNED_URL, "?senior_id=").concat(encodeURIComponent(idValue), "&files=").concat(encodeURIComponent(JSON.stringify(files)), "&version=").concat(encodeURIComponent(version), "&resource_version=").concat(encodeURIComponent(resource_version));
                    console.log('🔍 Final GET Signed URL:', url);
                    return [4 /*yield*/, API({
                            url: url,
                            method: APIMethod.Get,
                        })];
                case 1:
                    response = _b.sent();
                    if (response === null || response === void 0 ? void 0 : response.data) {
                        return [2 /*return*/, response.data];
                    }
                    else {
                        throw new Error('Failed to retrieve the signed URL.');
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _b.sent();
                    console.error('Error fetching the signed URL:', error_3);
                    throw error_3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
